var render = function (_h, _vm) {
  var _c = _vm._c
  return _c(
    "f-model",
    _vm._g(
      _vm._b(
        {
          staticClass: "f-users",
          attrs: { model: "User", collection: "Users" },
        },
        "f-model",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }